// extracted by mini-css-extract-plugin
export default {"heading":"Ut-z","corrected":"Vt-z","redirectVerbiageContainer":"Wt-z","redirectVerbiageText":"Xt-z"};